// All permissions for this module.
// Example of the constant:
// export const EXAMPLE_PERM = "Perm Id"

export const SEE_ACCOUNTS_PAYABLE_MODULE = 101;
export const SEE_ACCOUNTS_PAYABLE_REPORTING_PAGE = 1003;
